import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { downloadExcelFile } from 'features/Yucollect/utils/util';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ActivateAgencyRequest,
  activateAgencyFailure,
  activateAgencyRequest,
  activateAgencySuccess,
  downloadAgencyExcelRequest,
  fetchAgencyDetailsFailure,
  fetchAgencyDetailsRequest,
  fetchAgencyDetailsSuccess,
  fetchAllocatorAgencies,
  fetchAllocatorAgenciesFailure,
  fetchAllocatorAgenciesSuccess,
} from 'redux/slice/agency-onbording/Agency.slice';
import { IGetAllocatorAgencies } from 'redux/types/Agent.types';
import { agencyOnboarding, yucollectAdmin } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import { handleError } from '../utils/errorUtils';

const fetchAgencyDetailsApi = async (agencyId: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_AGENCY_BY_ID(agencyId)
  );
  return response.data;
};

const activateAgencyApi = async (agencyId: string) => {
  const response = await HTTPClient.PostRequest(
    agencyOnboarding.ACTIVATE_AGENCY_ON_PLATFORM(agencyId)
  );
  return response.data;
};

function* fetchAgencyDetailsRequestSaga(
  action: any
): Generator<any, void, any> {
  try {
    const agency = yield call(fetchAgencyDetailsApi, action.payload);
    yield put(fetchAgencyDetailsSuccess(agency));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch agency';
    yield put(fetchAgencyDetailsFailure(errorMessage));
  }
}

function* downloadAgenciesExcel(): any {
  try {
    const response = yield HTTPClient.PostRequest(
      yucollectAdmin.DOWNLOAD_AGENCY_EXCEL,
      {},
      { responseType: 'blob' }
    );
    if (!response.data) {
      throw new Error('No data received from the server');
    }
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    downloadExcelFile(blob, 'agencies.xlsx');
  } catch (error: any) {
    const errorMessage = 'Error while downloading excel';
    yield put(fetchAgencyDetailsFailure(errorMessage));
  }
}

function* activateAgencyRequestSaga(
  action: PayloadAction<ActivateAgencyRequest>
): Generator<any, void, any> {
  try {
    const { id } = action.payload;
    const agency = yield call(activateAgencyApi, id);
    yield put(activateAgencySuccess());
  } catch (error: any) {
    yield put(activateAgencyFailure());
  }
}

// Fetch campaigns by agent
function* handleAllocatorAgenciesSaga(
  action: PayloadAction<{ allocatorId: string }>
) {
  try {
    const { allocatorId } = action.payload;
    const response: AxiosResponse<IGetAllocatorAgencies> =
      yield HTTPClient.GetRequest(
        `${agencyOnboarding.GET_ALLOCATOR_AGENCIES(allocatorId)}`
      );
    yield put(fetchAllocatorAgenciesSuccess(response.data));
    // message.success('Campaigns fetched successfully');
  } catch (error: any) {
    yield* handleError(error, fetchAllocatorAgenciesFailure, '');
  }
}

export function* watchAgencySaga() {
  yield takeLatest(
    fetchAgencyDetailsRequest.type,
    fetchAgencyDetailsRequestSaga
  );
  yield takeLatest(downloadAgencyExcelRequest.type, downloadAgenciesExcel);
  yield takeLatest(activateAgencyRequest.type, activateAgencyRequestSaga);
  yield takeLatest(fetchAllocatorAgencies.type, handleAllocatorAgenciesSaga);
}
